import { AccountDataObject } from "../../types/AccountDataObject";
import { RoundsDataObject } from "../../types/RoundsDataObject";
import { SettingsDataObject } from "../../types/SettingsDataObject";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// props for this component
type GDPRprops = {
  userAccountData: AccountDataObject[] | null;
  userSettingsData: SettingsDataObject[] | null;
  userRoundsData: RoundsDataObject[] | null;
};

/**
 * Renders the GDPR information for the "/data" page
 * @returns html containing ...
 */
const GDPR = (props: GDPRprops) => {
  let userAccountData = props.userAccountData;
  let userSettingsData = props.userSettingsData;
  let userRoundsData = props.userRoundsData;

  // data to render
  const datas = [
    {
      name: "Account Data",
      data: userAccountData,
    },
    {
      name: "Settings Data",
      data: userSettingsData,
    },
    {
      name: "Rounds Data",
      data: userRoundsData,
    },
  ];

  return (
    <div className="p-4 flex flex-col gap-4">
      {datas.map((data) => (
        <div className="max-w-xl sm:max-w-3xl overflow-scroll" key={data.name}>
          <p className="text-lg font-semibold">Your {data.name}:</p>
          {data.data ? (
            data.data.map(
              (
                data: {
                  [key: string]: any;
                },
                i
              ) => (
                <div key={i}>
                  {Object.keys(data).map((key: string, i) => (
                    <p key={i}>{key + " : " + data[key]}</p>
                  ))}
                </div>
              )
            )
          ) : (
            <div className="max-w-3xl">
              {/** If data hasn't loaded display a skeleton */}
              <Skeleton count={5} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default GDPR;
